module.exports = __webpack_public_path__ + "static/fail-banner-tablet-9d180fed3e2cffdf2f844d9437fbf89f.jpg";